/** Add ActionTypes here. It will be easier to spot duplicates if they are all in the same file. */

// app
export const SET_VIEWPORT = "SET_VIEWPORT";
export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";

// Browse
export const GET_BROWSE_REQUEST = "GET_BROWSE_REQUEST";
export const GET_BROWSE_SUCCESS = "GET_BROWSE_SUCCESS";
export const GET_BROWSE_ERROR = "GET_BROWSE_ERROR";
export const GET_TOPICS_REQUEST = "GET_TOPICS_REQUEST";
export const GET_TOPICS_SUCCESS = "GET_TOPICS_SUCCESS";
export const GET_TOPICS_ERROR = "GET_BROWSE_ERROR";

// VIEWMODEL
export const GET_VIEWMODEL_REQUEST = "GET_VIEWMODEL_REQUEST";
export const GET_VIEWMODEL_SUCCESS = "GET_VIEWMODEL_SUCCESS";
export const GET_VIEWMODEL_ERROR = "GET_VIEWMODEL_ERROR";
export const SET_FILTERED_LIST = "SET_FILTERED_LIST";
export const RESET_FILTERED_LIST = "RESET_FILTERED_LIST";

// drug interactions
export const GET_DI_VIEWMODEL_REQUEST = "GET_DI_VIEWMODEL_REQUEST";
export const GET_DI_VIEWMODEL_SUCCESS = "GET_DI_VIEWMODEL_SUCCESS";
export const GET_DI_VIEWMODEL_ERROR = "GET_DI_VIEWMODEL_ERROR";
export const ADD_INPUT = "ADD_INPUT";
export const REMOVE_INPUT = "REMOVE_INPUT";
export const UPDATE_INPUT = "UPDATE_INPUT";
export const RESET_FORM = "RESET_FORM";
export const GET_SUGGESTIONS_SUCCESS = "GET_SUGGESTIONS_SUCCESS";
export const GET_SUGGESTIONS_ERROR = "GET_SUGGESTIONS_ERROR";
export const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS";
export const GET_DI_DETAILS_VIEWMODEL_SUCCESS =
  "GET_DI_DETAILS_VIEWMODEL_SUCCESS";
export const GET_DI_DETAILS_VIEWMODEL_ERROR = "GET_DI_DETAILS_VIEWMODEL_ERROR";
export const SET_INTERACTING_DETAILS = "SET_INTERACTING_DETAILS";
export const CLEAR_INTERACTING_DETAILS = "CLEAR_INTERACTING_DETAILS";
export const GET_DI_RESULTS_REQUEST = "GET_DI_RESULTS_REQUEST";
export const GET_DI_RESULTS_SUCCESS = "GET_DI_RESULTS_SUCCESS";
export const GET_DI_RESULTS_ERROR = "GET_DI_RESULTS_ERROR";
export const SET_SELECTED_INTERACTION_TYPE = "SET_SELECTED_INTERACTION_TYPE";
export const CACHE_PREVIOUS_DRUGS_CODES = "CACHE_PREVIOUS_DRUGS_CODES";

// follow
export const FOLLOW_SPECIALTY_REQUEST = "FOLLOW_SPECIALTY_REQUEST";
export const FOLLOW_SPECIALTY_SUCCESS = "FOLLOW_SPECIALTY_SUCCESS";
export const FOLLOW_SPECIALTY_ERROR = "FOLLOW_SPECIALTY_ERROR";
export const UNFOLLOW_SPECIALTY_REQUEST = "UNFOLLOW_SPECIALTY_REQUEST";
export const UNFOLLOW_SPECIALTY_SUCCESS = "UNFOLLOW_SPECIALTY_SUCCESS";
export const UNFOLLOW_SPECIALTY_ERROR = "UNFOLLOW_SPECIALTY_ERROR";

// specialties
export const FETCH_SPECIALTYDETAILS_REQUEST = "FETCH_SPECIALTYDETAILS_REQUEST";
export const FETCH_SPECIALTYDETAILS_SUCCESS = "FETCH_SPECIALTYDETAILS_SUCCESS";
export const FETCH_SPECIALTYDETAILS_ERROR = "FETCH_SPECIALTYDETAILS_ERROR";
export const FETCH_SPECIALTIES_REQUEST = "FETCH_SPECIALTIES_REQUEST";
export const FETCH_SPECIALTIES_SUCCESS = "FETCH_SPECIALTIES_SUCCESS";
export const FETCH_SPECIALTIES_ERROR = "FETCH_SPECIALTIES_ERROR";
export const CLEAR_SPECIALTY_DETAILS = "CLEAR_SPECIALTY_DETAILS";
